module.exports = __webpack_public_path__ + "img/Common.c1a0999c.jpg";